module.exports = __webpack_public_path__ + "media/1.d8c2044f.mp3";